export const PRECACHE_NAME = 'did-web-precache';

export async function registerSW() {
	if ('serviceWorker' in navigator) {
		navigator.serviceWorker
			.register('/sw.js', { scope: '/' })
			.then(reg => console.log('Service worker registered:', reg))
			.catch(err =>
				console.error('Service worker registration failed:', err)
			);

		navigator.serviceWorker.addEventListener('controllerchange', () => {
			// Optional: reload page when new SW activates
			window.location.reload();
		});
	}
}
